/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Notificationservicehuburlclientsecret5Inputs */

const en_entity_notificationservicehuburlclientsecret5 = /** @type {(inputs: Entity_Notificationservicehuburlclientsecret5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Service Hub Client Secret`)
};

const de_entity_notificationservicehuburlclientsecret5 = /** @type {(inputs: Entity_Notificationservicehuburlclientsecret5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungsservice Hub Client Secret`)
};

/**
* | output |
* | --- |
* | "Notification Service Hub Client Secret" |
*
* @param {Entity_Notificationservicehuburlclientsecret5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_notificationservicehuburlclientsecret5 = /** @type {((inputs?: Entity_Notificationservicehuburlclientsecret5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Notificationservicehuburlclientsecret5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_notificationservicehuburlclientsecret5(inputs)
	return de_entity_notificationservicehuburlclientsecret5(inputs)
});
export { entity_notificationservicehuburlclientsecret5 as "entity_notificationServiceHubUrlClientSecret" }